module.exports = __webpack_public_path__ + "img/attachment_icon.113a469e.svg";